import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"
import type { ImportStatus } from "../api/types/imports"
import type { McPillTone } from "../components/shared/McPill"

const ANALYZING: ImportStatus[] = ["uploaded", "parsing", "extracting"]

/** A failed analysis is reverted to `uploaded` with its error kept, awaiting a retry. */
export function isAnalysisFailed(file: {
  status: ImportStatus
  error?: string | null
}): boolean {
  return file.status === "uploaded" && !!file.error
}

/** Label and pill tone for one import, shared by the history list and the agent chat. */
export function importStatusDisplay(file: {
  status: ImportStatus
  analysisError?: string | null
}): { key: TranslationKeys; tone: McPillTone } {
  if (file.status === "committed")
    return { key: "MC_MD_IMPORT_STATUS_COMMITTED", tone: "success" }
  if (file.status === "failed" || file.analysisError)
    return { key: "MC_MD_IMPORT_STATUS_FAILED", tone: "danger" }
  if (ANALYZING.includes(file.status))
    return { key: "MC_MD_IMPORT_STATUS_ANALYZING", tone: "info" }
  if (file.status === "committing")
    return { key: "MC_MD_IMPORT_STATUS_COMMITTING", tone: "info" }
  return { key: "MC_MD_IMPORT_STATUS_STAGED", tone: "attention" }
}
